import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a89610f755b8c001430266e_1788186907221_26e57841/listing_1787388175407/src/app/search/page.tsx");
